var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.980469,
    y: 0.00488281,
    width: 38.1696,
    height: 37.1651,
    rx: 18.5826,
    fill: "#FF510D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0645 9.3237C25.4399 9.3237 29.7952 13.679 29.7952 19.0544C29.7952 24.4299 25.4399 28.7852 20.0645 28.7852C14.689 28.7852 10.3337 24.4299 10.3337 19.0544C10.3337 13.679 14.689 9.3237 20.0645 9.3237ZM23.6742 21.6048C23.7527 21.5263 23.8312 21.3694 23.8312 21.2124C23.8312 21.0163 23.7135 20.8593 23.5958 20.7416L21.32 19.0544V13.4043C21.32 13.0904 21.0061 12.7765 20.6922 12.7765H19.4367C19.0835 12.7765 18.8089 13.0904 18.8089 13.4043V19.5253C18.8089 20.0353 19.0051 20.4669 19.3974 20.7416L22.0263 22.7034C22.1048 22.7819 22.2617 22.8604 22.3794 22.8604C22.6148 22.8604 22.7718 22.7427 22.8895 22.5857L23.6742 21.6048Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalStep);
export default __webpack_public_path__ + "static/media/final-step.6ed3e0d69ca6135d3b67875c755b4d7d.svg";
export { ForwardRef as ReactComponent };